<mat-toolbar color="primary">
  <mat-toolbar-row class="container">
    <span>{{ 'modals.import-clinical-onboarding-candidates.title' | translate }}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="close()"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<div class="container my-5">
  <p class="text-muted small mb-4">{{ 'modals.import-clinical-onboarding-candidates.hint' | translate }}</p>

  @if (loading) {
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  } @else if (dataSource.data.length === 0) {
    <div class="empty-state text-muted">{{ 'modals.import-clinical-onboarding-candidates.none-ready' | translate }}</div>
  } @else {
    <div class="table-container-rounded">
      <mat-table [dataSource]="dataSource" class="w-100 table-primary">
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef class="col-centered">
            <mat-checkbox [checked]="isAllSelected" (change)="toggleAll()"></mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            <mat-checkbox [checked]="selection.isSelected(row)" (change)="selection.toggle(row)"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef class="left">{{ 'generic.name' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="left">
            <div class="member-info">
              <span class="member-name">{{ row.name || '-' }}</span>
              <span class="member-email text-muted small">{{ row.email }}</span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="macro_status">
          <mat-header-cell *matHeaderCellDef class="col-centered">{{ 'components.clinical-onboarding.dashboard.column-macro-status' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="col-centered">
            <app-clinical-onboarding-status-badge [macroStatus]="row.macro_status"></app-clinical-onboarding-status-badge>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </div>
  }
</div>

<div class="buttons-container container mb-3 d-flex justify-content-center">
  <button mat-stroked-button class="text-dark-purple border-purple mr-2" [disabled]="importing" (click)="close()">{{ 'generic.buttons.cancel-and-back' | translate }}</button>
  <button mat-raised-button color="primary" [disabled]="importing || selection.selected.length === 0" (click)="confirmImport()">
    {{ 'modals.import-clinical-onboarding-candidates.confirm' | translate:{count: selection.selected.length} }}
  </button>
</div>
